import qs from 'qs';
import Cookies from 'js-cookie';
import request from 'superagent';
import {getAuthParams} from 'providers/user/utils';
import {domain} from 'ferries/helpers/common';

const STORAGE_CUID = 'cuid';

const getCuidFromServer = async () => {
  const authParams = getAuthParams();

  if (!authParams?.email) {
    return;
  }

  const tp24Id = Cookies.get('TP24ID');
  const {body} = await request
    .get(`${domain}/api/v1/ferries/user-identity`)
    .set({'Content-Type': 'application/json', 'Accept': 'application/json'})
    .query([`email=${authParams.email}`, `tp24Id=${tp24Id}`].join('&'))
    .ok(({status}) => [200, 401].includes(status))
    .then(({body, status}) => ({body, status}));

  return body?.response?.result?.cuid;
};

const generateUUID = () => {
  const d = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16)%16 | 0;
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
};

const setCustomerUserId = async () => {
  const cuidFromServer = await getCuidFromServer();
  const {cuid: cuidParam} = qs.parse(location.search.slice(1));
  const cuidStorage = localStorage.getItem(STORAGE_CUID);

  const cuid = cuidFromServer ?? cuidParam ?? cuidStorage ?? generateUUID();
  
  if (cuid) {
    localStorage.setItem(STORAGE_CUID, `${cuid}`);
  }
};

export {setCustomerUserId};